module.exports = __webpack_public_path__ + "img/gl.2490aa08.svg";